import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import useApi from "../../../core/customhook/useApi";
interface LeavePieChartProps {
    financial_year: string;
}

const LeavePieChart: React.FC<LeavePieChartProps> = ({ financial_year }) => {
    const formatFinancialYear = (year: number) => {
        const nextYearShort = (year + 1).toString().slice(-2);
        return `${year}-${nextYearShort}`;
    };

    const getFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        return formatFinancialYear(year);
    };

    const [finance_year, setFinance_year] = useState(getFinancialYear());


    const {
        data: monthlyLeaveData,
        loading: leave_balance_loading,
        error: leave_balance_error,
    } = useApi("/api/get-monthly-leave-details", {
        method: "POST",
        payload: {
            financial_year: financial_year,
        },
        autoCall: true,
        dependencies: [financial_year],
    });


    useEffect(() => {
        console.log(finance_year, "finance_year");
        console.log(monthlyLeaveData?.data, "monthlyLeaveData");
    }, [])



    // const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // const values = [0, 1, 13, 30, 31, 30, 31, 31, 16, 0, 0, 0];



    // Extract months & values when API data is ready
    const months: string[] =
        monthlyLeaveData?.monthlySummary
            ? Object.keys(monthlyLeaveData.monthlySummary).map((m) =>
                m.slice(0, 3) // "January" -> "Jan"
            )
            : [];

    const values: number[] =
        monthlyLeaveData?.monthlySummary
            ? Object.values(monthlyLeaveData.monthlySummary) as number[]
            : [];


    const options: ApexCharts.ApexOptions = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
        },
        colors: ["#2e3294"], // soft yellow
        plotOptions: {
            bar: {
                columnWidth: "40%",
                distributed: true,
                dataLabels: {
                    position: "top",
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => (typeof val === "number" ? val.toString() : ""),
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#555"],
            },
        },

        xaxis: {
            categories: months,
            position: "bottom",
            labels: {
                style: {
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        grid: {
            show: false,
        },

    };


    return (
        <div
            style={{
                width: "100%",
                maxWidth: "1000px",
                margin: "auto",
                textAlign: "center",
            }}
        >
            <h4
                style={{
                    textAlign: "center",
                    margin: "50px 0px 20px 0",
                    position: "relative",
                    display: "inline-block",
                    paddingBottom: "8px",
                }}
            >
                <strong>Monthly Availed Leave Summary</strong>
                <span
                    style={{
                        content: "''",
                        position: "absolute",
                        left: 0,
                        bottom: 0,
                        height: "3px",
                        width: "100%",
                        backgroundColor: "#fbc02d", // underline color (soft yellow)
                        borderRadius: "2px",
                    }}
                />
            </h4>

            {/* <Chart
                options={options}
                series={[{ data: values }]}
                type="bar"
                height={250}
            /> */}
            <Chart
                options={options}
                series={[{ name: "Leaves", data: values }]}
                type="bar"
                height={250}
            />
        </div>
    );
};

export default LeavePieChart;
